

import { LoadingProps } from "shared/typings/ViewTypes";
import {Updater,SplitLayout} from "@npd-ng/adp-component-library";
import { IADPState } from "shared/typings";
import {useSelector } from "react-redux";
export const LoadingView = () => {
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  );
  const loadingProps: LoadingProps = {
    title: state.currentLanguageContent?.initialWait.title || "",
    message: state.currentLanguageContent?.initialWait.message || "",
    subTitle: state.currentLanguageContent?.initialWait.subTitle || "",
    spinnerAlt:state.currentLanguageContent?.imageAltText.verifyingIcon as string
  };
  return (
    <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string}>
      <Updater {...loadingProps} type="wait" />
    </SplitLayout>
  )
  
}


